export default {
    props: {
        positionTop: {
            type: [Number, String],
            default: undefined,
            kComposite: 'position.top'
        }, 
        positionLeft: {
            type: [Number, String],
            default: undefined,
            kComposite: 'position.left'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Position.js